/**
 * Storage content-type colour/label helpers.
 *
 * Extracted verbatim from StorageFilesTab.jsx during the Phase 6 refactor
 * (no behaviour change).
 */
export const TYPE_COLORS = {
  pptx: '#EA580C', pdf: '#DC2626', png: '#2563EB', jpeg: '#0EA5E9',
  webp: '#0D9488', mp4: '#7C3AED', svg: '#65A30D', default: '#64748B',
};

// Map MIME → short display label (and color key)
export const MIME_LABEL = {
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/pdf': 'pdf',
  'application/json': 'json',
  'text/plain': 'txt',
  'text/csv': 'csv',
  'image/png': 'png',
  'image/jpeg': 'jpeg',
  'image/webp': 'webp',
  'image/svg+xml': 'svg',
  'image/gif': 'gif',
  'video/mp4': 'mp4',
  'video/quicktime': 'mov',
  'application/octet-stream': 'file',
};

export function shortType(mime) {
  if (!mime) return 'file';
  if (MIME_LABEL[mime]) return MIME_LABEL[mime];
  // Fallback: take last segment after '/' or '.', capped to 8 chars
  const last = (mime.split('/').pop() || mime).split('.').pop();
  return (last || 'file').slice(0, 8);
}

export function colorForType(t) {
  const key = shortType(t).toLowerCase();
  return TYPE_COLORS[key] || TYPE_COLORS.default;
}
